import { Cookies } from 'react-cookie';

import { VisitToObject } from '../type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getVisitsToObject = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/create-visit-report-document/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as VisitToObject[];
};
